export default {
  // Get feed report data
  getFeedReportData: (state) => state.feedReportData,
  
  // Get loading states
  isLoadingFeedData: (state) => state.loadingFeedData,
  isLoadingQueues: (state) => state.loadingQueues,
  isLoadingUsers: (state) => state.loadingUsers,
  
  // Get error states
  getFeedDataError: (state) => state.feedDataError,
  
  // Get available options
  getAvailableQueues: (state) => state.availableQueues,
  getAvailableUsers: (state) => state.availableUsers,
  
  // Get current selections
  getSelectedQueues: (state) => state.selectedQueues,
  getSelectedUsers: (state) => state.selectedUsers,
  getSelectedDateRange: (state) => state.selectedDateRange,
  getDateType: (state) => state.dateType,
  
  // MT-style group getters for compatibility
  getGroupNames: (state) => {
    const groups = []
    state.availableUsers.forEach(user => {
      if (user.groupName && !groups.includes(user.groupName)) {
        groups.push(user.groupName)
      }
    })
    return groups
  },
  
  getUsersByGroupName: (state) => (groupName) => {
    return state.availableUsers.filter(user => user.groupName === groupName)
  },
  
  // Check if has data
  hasFeedReportData: (state) => {
    if (!state.feedReportData) return false
    
    // Check for new API format: { statusCode, data: [] }
    if (state.feedReportData.data && Array.isArray(state.feedReportData.data)) {
      return state.feedReportData.data.length > 0
    }
    
    // Fallback for array format
    if (Array.isArray(state.feedReportData)) {
      return state.feedReportData.length > 0
    }
    
    // Fallback for object format
    return Object.keys(state.feedReportData).length > 0
  },
  
  // Check if has selections - artık zorunlu değil, her zaman true döner
  hasSelections: () => {
    // Seçim zorunlu değil, widget her zaman çalışabilir
    return true
  }
}